var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"cta-button",class:[_vm.classHandler, _vm.buttonType, _vm.shape],style:(_vm.colorHandler),attrs:{"href":_vm.clickoutLink,"aria-label":_vm.ariaLabel,"target":"_blank","rel":"nofollow"},on:{"click":function($event){return _vm.onClick()}}},[_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }